import React, { useEffect, useState } from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { useCryptoPrices } from '../hooks/useCryptoPrices';
import { SWAP_TOKENS } from '../mock';

const DEFAULT_IDS = ['bitcoin', 'ethereum', 'tether', 'solana', 'binancecoin', 'ripple', 'litecoin', 'dogecoin', 'cardano', 'polkadot', 'avalanche-2', 'chainlink'];

const PriceTicker = () => {
  const { data, status } = useCryptoPrices(DEFAULT_IDS);
  const [prev, setPrev] = useState({});

  useEffect(() => {
    // Track previous price to color up/down between refreshes
    if (status === 'ready') {
      setPrev(prevMap => {
        const next = { ...prevMap };
        Object.keys(data).forEach(k => { if (next[k] === undefined) next[k] = data[k].price; });
        return next;
      });
    }
  }, [data, status]);

  // Fallback: if API not ready, use static SWAP_TOKENS as filler
  const items = DEFAULT_IDS.map(id => {
    const live = data[id];
    if (live) return { id, symbol: live.symbol, name: live.name, image: live.image, price: live.price, change: live.change24h, prev: prev[id] ?? live.price };
    const fallback = SWAP_TOKENS.find(t => t.cgId === id);
    return fallback ? { id, symbol: fallback.symbol, name: fallback.name, image: fallback.logo, price: fallback.usd, change: 0, prev: fallback.usd } : null;
  }).filter(Boolean);

  const loop = [...items, ...items];

  return (
    <div className="bg-neutral-950 text-white border-y border-white/10 overflow-hidden relative">
      <div className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none" style={{ background: 'linear-gradient(90deg, #0a0a0a, transparent)' }} />
      <div className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none" style={{ background: 'linear-gradient(270deg, #0a0a0a, transparent)' }} />
      <div className="flex animate-marquee whitespace-nowrap py-3">
        {loop.map((p, i) => {
          const up = (p.change ?? 0) >= 0;
          const priceStr = p.price >= 1 ? p.price.toLocaleString(undefined, { maximumFractionDigits: 2 }) : p.price.toFixed(4);
          return (
            <div key={i} className="flex items-center gap-2 px-6 shrink-0 text-sm border-r border-white/5">
              <img src={p.image} alt={p.symbol} className="w-5 h-5 rounded-full" onError={(e) => e.currentTarget.style.display = 'none'} />
              <span className="font-semibold text-white/90">{p.symbol}</span>
              <span className="text-white/60">${priceStr}</span>
              <span className={`flex items-center text-xs ${up ? 'text-emerald-400' : 'text-rose-400'}`}>
                {up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                <span className="ml-0.5">{Math.abs(p.change ?? 0).toFixed(2)}%</span>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PriceTicker;
